import { type PortalMember } from "@/hooks/useUsers";
import {
  Button,
  FormDialog,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@simplicity/ui";
import { useState } from "react";

export function AddMemberDialog({
  open,
  onOpenChange,
  availableUsers,
  isPending,
  onAdd,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  availableUsers: PortalMember[];
  isPending: boolean;
  onAdd: (userId: string) => void;
}) {
  const [selectedUserId, setSelectedUserId] = useState("");

  const handleAdd = () => {
    if (!selectedUserId) return;
    onAdd(selectedUserId);
    setSelectedUserId("");
  };

  return (
    <FormDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Add Member"
      description="Select a tenant user to add to this group."
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleAdd} disabled={isPending || !selectedUserId}>
            {isPending ? "Adding..." : "Add"}
          </Button>
        </>
      }
    >
      {availableUsers.length === 0 ? (
        <p className="text-sm text-muted-foreground">All tenant users are already in this group.</p>
      ) : (
        <Select value={selectedUserId} onValueChange={setSelectedUserId}>
          <SelectTrigger size="sm" autoFocus aria-label="Select user to add">
            <SelectValue placeholder="Select a user..." />
          </SelectTrigger>
          <SelectContent>
            {availableUsers.map((u) => (
              <SelectItem key={u.userId} value={u.userId}>
                {u.name ? `${u.name} (${u.email})` : u.email}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </FormDialog>
  );
}
